import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  // Set item in local storage
  setItem(key: string, value: any): void {
    localStorage.setItem(key, value);
  }

  // Get item from local storage
  getItem(key: string): any {
    return localStorage.getItem(key);
  }

  // Remove item from local storage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all items from local storage
  clear(): void {
    localStorage.clear();
  }
}